module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Deadline-Gallipoli.4e2be2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Deadline-Gallipoli.jpg
// module id = PPta
// module chunks = 0